import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { mobileMenu } from "../../../utils";

function MobileMainNav(props) {
  const REACT_APP_PUBLIC_URL = "/react/molla";
  const [path, setPath] = useState("");

  let brands = props.brands;

  useEffect(() => {
    setPath(window.location.href);
  });

  React.useEffect(() => {
    mobileMenu();
  });

  return (
    <nav className="mobile-nav">
      <ul className="mobile-menu">
        <li className={`megamenu-container`} id="menu-home">
          <Link to={`${process.env.REACT_APP_PUBLIC_URL}`}>Accueil</Link>
        </li>

        {/* path.indexOf( "shop" ) > -1 ? 'active' : */}

        <li className={""}>
          <Link to={`${process.env.REACT_APP_PUBLIC_URL}/shop/sidebar/list`}>
            Boutique
          </Link>
        </li>

        {/*<li className={ path.indexOf( "/brand" ) > -1 ? 'active' : '' }>
                    
                    <Link to={ `${process.env.PUBLIC_URL}/shop/sidebar/list` }>
                        Marques
                    </Link>

                    <ul>
                    {
                            brands.slice(0, 20).map( ( item, index ) =>
                            
                                <li className={ path.indexOf( "blog/classic" ) > -1 ? 'active' : '' }>
                                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/bybrand/${item.slug}` }>{item.nameFr}</Link>
                                </li>
                            )
                    }
                    </ul>
                    
                </li>*/}

        <li className={""}>
          <Link to={`${process.env.REACT_APP_PUBLIC_URL}/pages/about`}>
            À propos
          </Link>
        </li>

        <li className={""}>
          <Link to={`${process.env.REACT_APP_PUBLIC_URL}/pages/contact`}>
            Contacts
          </Link>
        </li>

        <li className={""}>
          <Link to={`${process.env.REACT_APP_PUBLIC_URL}/shop/wishlist`}>
            Favorits
          </Link>
        </li>

        <li className={""}>
          <Link to={`${process.env.REACT_APP_PUBLIC_URL}/shop/cart`}>
            Panier
          </Link>
        </li>
      </ul>
    </nav>
  );
}

function mapStateToProps(state) {
  return {
    brands: state.brands.brands ? state.brands.brands : [],
  };
}

export default connect(mapStateToProps, null)(MobileMainNav);
